import styled from 'styled-components';

import { mediaHover, rem } from 'approot/shared/style';
import { standardFocusStateInset } from 'approot/shared/styles/borders.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { grey1, grey4 } from 'approot/shared/styles/colours.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';

export const EditorControlAddBetween = styled(SecondaryButton)`
  ${baseFlexCss}
  ${standardFocusStateInset}

  border: none;
  border-radius: 0;
  height: ${rem(24)};
  justify-content: center;
  margin-left: ${rem(35)};
  opacity: 1;
  padding: 0;
  position: relative;
  width: ${rem(128)};

  ${mediaHover`
    opacity: 0;
  `}

  &:before {
    background-color: ${grey4};
    content: '';
    height: 1px;
    margin-top: -1px;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    z-index: 1;
  }

  svg {
    fill: ${grey1};
    z-index: 2;
  }

  &:hover,
  &:focus {
    background-color: transparent;
    cursor: pointer;
  }

  &.is-active,
  &:hover,
  &:focus {
    opacity: 1;
  }

  &:disabled {
    background-color: transparent !important;
    svg {
      stroke: ${grey4};
    }
  }
`;
